import React, { useContext, useEffect, useRef } from "react";
import { enqueueSnackbar } from "notistack";
import { useQueryClient } from "@tanstack/react-query";
import { AppContext } from "../../AppContext";
import { announceStorefrontOrder } from "./storefrontChime";

export default function RestaurantOrderNotifier() {
    const { socket, restaurantSettings, isRetailPos } = useContext(AppContext);
    const queryClient = useQueryClient();
    const seen = useRef(new Set());
    const enabled = !isRetailPos && Number(restaurantSettings?.docs?.[0]?.restaurant_storefront_enabled) === 1;
    useEffect(() => {
        if (!enabled || !socket?.on) return undefined;
        const handleOrder = (order) => {
            if (!order?.name || seen.current.has(order.name)) return;
            seen.current.add(order.name);
            void announceStorefrontOrder(order.name);
            queryClient.invalidateQueries(["draftTakeawayOrders"]);
            queryClient.invalidateQueries(["restaurantStorefrontStaff", "orders"]);
            enqueueSnackbar(`New online order ${order.name} from ${order.customer_name || "customer"}`, {
                variant: "info",
                persist: true,
                action: () => <a href="/restaurant-orders" style={{ color: "inherit", fontWeight: 800 }}>Open</a>,
            });
        };
        socket.on("restaurant_storefront_order_created", handleOrder);
        return () => {
            if (socket.off) socket.off("restaurant_storefront_order_created", handleOrder);
            else socket.removeListener?.("restaurant_storefront_order_created", handleOrder);
        };
    }, [enabled, queryClient, socket]);
    return null;
}
